import { BaseService } from '../../infra/base.service'
import type { AutomationGroup } from './automation-group'
import type { AutomationGroupsRepository } from './automation-groups.repository'

export class AutomationGroupsService extends BaseService<AutomationGroup> {
    constructor(private rep: AutomationGroupsRepository) {
        super(rep)
    }
}
